import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Stack from 'atoms/Layout/Stack/Stack';
import FreeTrialEmailBlock from 'molecules/FreeTrialEmailBlock/FreeTrialEmailBlock';
import { IStaticContentfulImages } from 'src/types/contentful';
import FrostedOverlay from 'molecules/FrostedOverlay/FrostedOverlay';
import { StaticContainer } from './HeroBannerFilmStripWithEmail.styles';
import { GatsbyImage } from 'gatsby-plugin-image';
import useOnMobile from 'src/hooks/useOnMobile';

const HeroBannerFilmStripWithEmail = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      filmStripImage: contentfulAsset(contentful_id: { eq: "3GCLbv2WmFOc8qCKx9w0px" }) {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, width: 3200)
      }
    }
  `);

  const isMobile = useOnMobile();

  return (
    <Stack
      fullWidth
      position='relative'
      align='center'
      justify='center'
    >
      <StaticContainer>
        <GatsbyImage
          image={images.filmStripImage.gatsbyImageData}
          alt='Community screenshots showcasing real Mighty Networks communities'
        />
      </StaticContainer>
      <FrostedOverlay
        direction='column'
        align='center'
        margin={['spacing-8xl', 'spacing-none']}
        padding={['spacing-6xl', 'spacing-10xl']}
        paddingSm={['spacing-3xl', 'spacing-2xl']}
      >
        <Stack
          fullWidth
          maxWidth='width-xl'
        >
          <FreeTrialEmailBlock
            formWrapperId='homepage-hero-free-trial-form'
            hideHelperText={isMobile}
          />
        </Stack>
      </FrostedOverlay>
    </Stack>
  );
};

export default HeroBannerFilmStripWithEmail;
